import { uri } from '../../api-endpoint';
import {
  IModelAPIValidationError,
  IModelFromAPISuccessResponse
} from '../../type-conversion/model/from-api-repsonse';
import { fetchWithBodyTemplateFn } from '../common/base/fetch-with-body-template-fn';

export const startTraining = (token: string) => (modelId: number) =>
  fetchWithBodyTemplateFn('POST')(
    token,
    uri.modelTrain(modelId),
    () => ({}),
    IModelFromAPISuccessResponse,
    IModelAPIValidationError
  );
